import React from 'react';
import { Menu } from 'antd';

export default function MessageMenu({ onDelete }) {
  return (
    <Menu
      items={[
        {
          key: '1',
          label: 'Excluir mensagem',
          onClick: () => onDelete(),
        },
      ]}
    />
  );
}
